<template>

  <PrevisionaleDispacciamento />
 
</template>

<script>
import PrevisionaleDispacciamento from '../components/pratiche/PrevisionaleDispacciamento.vue'

export default {
  components: {
    PrevisionaleDispacciamento

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

